<template>
  <v-toolbar>
    <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="toggleDrawler"></v-toolbar-side-icon>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down" v-if="Vue.$store.state.config.language === 'ro'">
      <v-btn flat class="nav-links" to="/">{{ $t('navbar.predict') }}</v-btn>
      <v-btn flat class="nav-links" to="/clasament">{{ $t('navbar.list') }}</v-btn>
      <v-btn flat class="nav-links" to="/premii">{{ $t('navbar.gifts') }}</v-btn>
      <v-btn flat class="nav-links" to="/reguli">{{ $t('navbar.rules') }}</v-btn>
    </v-toolbar-items>
    <v-toolbar-items class="hidden-sm-and-down" v-else>
      <v-btn flat class="nav-links" to="/ru" exact>{{ $t('navbar.predict') }}</v-btn>
      <v-btn flat class="nav-links" to="/ru/turnirnaja-tablica">{{ $t('navbar.list') }}</v-btn>
      <v-btn flat class="nav-links" to="/ru/prizy">{{ $t('navbar.gifts') }}</v-btn>
      <v-btn flat class="nav-links" to="/ru/uslovija">{{ $t('navbar.rules') }}</v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div>
      <v-btn
          color="pink"
          flat
          @click="notify()"
      >
        <v-icon>notifications</v-icon>
        <span class="ui-visible@m">{{ $t('navbar.notify') }}</span>
      </v-btn>
      <v-dialog v-model="dialog" width="1000">
        <v-card class="truepush" height="450">
          <a href="javascript:void(0)" class="ui-top-right" @click="dialog = false">
            <v-icon>close</v-icon>
          </a>
          <v-card-text>
            <h3 v-html="$t('dialog.title')"></h3>
            <p v-html="$t('dialog.text')"></p>
            <v-btn flat href="https://t.me/enteronline" target="_blank">
              {{ $t('navbar.notify') }}
            </v-btn>
          </v-card-text>

        </v-card>
      </v-dialog>
    </div>
    <span style="color: #E0E3E8">|</span>
    <v-btn
        flat
        href="https://t.me/enteronline"
        target="_blank"
    >
      <telegram-icon class="mr-1"/>
      {{ $t('chat') }}
    </v-btn>
    <span style="color: #E0E3E8">|</span>
    <v-btn icon @click="lang" class="nav-social">
      <span v-if="Vue.$store.state.config.language === 'ro'">RU</span>
      <span v-else>RO</span>
    </v-btn>
  </v-toolbar>
</template>

<script>
import TelegramIcon from '../icons/TelegramIcon'

export default {
  name: 'navbar',
  components: {TelegramIcon},
  data () {
    return {
      Vue: this,
      dialog: false
    }
  },
  created () {
    if (!localStorage.getItem('telegram')) {
      setTimeout(() => {
        localStorage.setItem('telegram', true)
        this.dialog = true
      }, 40000)
    }
  },
  methods: {
    toggleDrawler () {
      let drawler = this.$store.state.config.drawler
      this.$store.commit('var', {type: 'config', i: 'drawler', v: !drawler})
    },
    lang () {
      let lang = this.$store.state.config.language
      if (lang === 'ro') lang = 'ru'; else lang = 'ro'
      this.$store.commit('var', {type: 'config', i: 'language', v: lang})
      this.$i18n.locale = lang
      let routes = {
        '/': '/ru',
        '/ru': '/',
        '/clasament': '/ru/turnirnaja-tablica',
        '/ru/turnirnaja-tablica': '/clasament',
        '/premii': '/ru/prizy',
        '/ru/prizy': '/premii',
        '/reguli': '/ru/uslovija',
        '/ru/uslovija': '/reguli'
      }
      this.$router.push(routes[this.$router.currentRoute.path])
    },
    href () {
      let param = this.$store.state.config.language === 'ro' ? '/' : '/ru'
      return `${param}`
    },
    notify () {
      var truepush = window.truepush || []
      truepush.subscribeUserVapid()
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/navbar.vue